import React, { CSSProperties } from "react";
import { Avatar, useTheme } from "@mui/material";
import Color from "color";
import AvatarIcon from "@/assets/icons/lead-page/avatar-icon";

export interface AvatarProps {
  url?: string;
  name?: string;
  alt?: string;
  color?: string | null;
  size?: number;
  fontSize?: CSSProperties;
  icon?: React.ReactElement;
}

export const CommonAvatar: React.FC<AvatarProps> = ({
  url,
  name,
  alt,
  color,
  size = 20,
  fontSize,
  icon,
}) => {
  const theme = useTheme();
  const firstLetter = name ? name.charAt(0).toUpperCase() : null;

  const colorObj = color ? new Color(color) : new Color("#e5e7eb");

  return (
    <Avatar
      src={url}
      alt={alt || `${name || "User"} avatar`}
      sx={{
        width: size,
        height: size,
        fontSize:
          fontSize || theme.nawy.typography.english.variants.body.md.regular,
        fontWeight: 500,
        bgcolor: colorObj.alpha(0.2).toString() || "#e5e7eb",
        color: colorObj.darken(0.5).toString() || "#374151",
      }}
    >
      {icon || firstLetter || <AvatarIcon />}
    </Avatar>
  );
};

export default CommonAvatar;
